import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Spinner from './Spinner';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <Spinner size="lg" color="blue" />
          <div className="text-xl" style={{ color: '#0E60C6' }}>Caricamento...</div>
        </div>
      </div>
    );
  }

  if (!user) {
    // Redirect to login with message and return URL
    return <Navigate to="/login" state={{ from: location, message: 'Devi effettuare il login per accedere a questa pagina' }} replace />;
  }

  return children;
}
